/**
 * Active company for API paths / X-Company-Id.
 * Never fall back to REACT_APP_COMPANY_ID — that bake-in caused 403s for
 * accountants (and others) with no linked company while Manage Company still fired.
 */
export function getActiveCompanyId() {
    return localStorage.getItem("companyId") || null;
}

export function getLinkedCompanies() {
    try {
        const list = JSON.parse(localStorage.getItem("userCompanies") || "[]");
        return Array.isArray(list) ? list : [];
    } catch {
        return [];
    }
}

/** Routes that do not need a selected company (accountant empty state, firm billing, etc.). */
const COMPANY_OPTIONAL_PATHS = [
    "/dashboard/my-companies",
    "/dashboard/billing",
    "/dashboard/account-settings",
];

export function isCompanyOptionalPath(pathname = "") {
    const path = (pathname || "").toLowerCase().replace(/\/+$/, "") || "/";
    return COMPANY_OPTIONAL_PATHS.some(
        (p) => path === p || path.endsWith(p) || path.includes(p)
    );
}

/**
 * Company/accountant portal users must pick or add a company before
 * company-scoped APIs (Manage Company, employees, payroll, etc.).
 */
export function mustSelectCompany() {
    const role = (localStorage.getItem("userRole") || "").toLowerCase();
    if (!role) return false;
    if (role.includes("employee") || role.includes("contractor") || role.includes("reseller") || role.includes("super")) {
        return false;
    }
    if (!getActiveCompanyId() && getLinkedCompanies().length === 0) {
        return true;
    }
    return !getActiveCompanyId();
}
